import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
	archiveEmployee,
	changeActiveFilter,
	deleteFromArchiveEmployee,
	getAcriveEmployees,
	getAllEmployees,
	getEmployee,
	getOrganizationEmployees,
	getOrganizationsName,
} from "./employees.thunks";
import { EmployeeResponse } from "libs/apiClient/data-contracts";

interface EmployeesState {
	employeesList: EmployeeResponse[];
	employeesFilters: {
		department: { [key: string]: any }[];
		position: { [key: string]: any }[];
		relationship: { [key: string]: any }[];
		status: { [key: string]: any }[];
	};
	selectedEmployee: any | null;
	organizationsName: any[];
}

const initialState: EmployeesState = {
	employeesList: [],
	employeesFilters: {
		department: [],
		position: [],
		relationship: [],
		status: [],
	},
	selectedEmployee: null,
	organizationsName: [],
};

const employeesSlice = createSlice({
	name: "employeesSlice",
	initialState,
	reducers: {
		setEmployees(
			state,
			action: PayloadAction<{
				data: any;
				change: boolean;
				filterData?: boolean;
			}>,
		) {
			const { change, data, filterData } = action.payload;
			if (change) {
				state.employeesList = data.list;
				if (filterData) {
					let position = [
						{
							id: 0,
							name: "По умолчанию",
							column: "position",
							active: true,
						},
						...Object.values(data.possibleFilters.position as { [key: string]: any }).map(
							(_: string, index: number) => ({
								column: "position",
								active: false,
								name: _,
								id: index + 1,
							}),
						),
					];
					let status = [
						{
							id: 0,
							name: "По умолчанию",
							column: "status",
							active: true,
						},
						...Object.values(data.possibleFilters.status as { [key: string]: any }).map((_: string, index: number) => ({
							column: "status",
							active: false,
							name: _,
							id: index + 1,
						})),
					];
					let department = [
						{
							id: 0,
							name: "По умолчанию",
							column: "department",
							active: true,
						},
						...Object.values(data.possibleFilters.department as { [key: string]: any }).map(
							(_: string, index: number) => ({
								column: "department",
								active: false,
								name: _,
								id: index + 1,
							}),
						),
					];

					let relationship = [
						{
							id: 0,
							name: "По умолчанию",
							column: "relationship",
							active: true,
						},
						...Object.values(data.possibleFilters.relationship as { [key: string]: any }).map(
							(_: string, index: number) => ({
								column: "relationship",
								active: false,
								name: _,
								id: index + 1,
							}),
						),
					];

					state.employeesFilters = {
						relationship,
						department,
						status,
						position,
					};
				}
			} else {
				state.employeesList = [...state.employeesList, ...data.list];
			}
		},
	},
	extraReducers: (builder) => {
		builder.addCase(getAllEmployees.fulfilled, (state, action: PayloadAction<any>) => {
			const { possibleFilters, list, change } = action.payload;
			state.employeesList = list;
			let department: any[] = [],
				position: any[] = [],
				relationship: any[] = [],
				status: any[] = [];
			if (change) {
				department = [
					{
						id: 0,
						name: "По умолчанию",
						column: "department",
						active: true,
					},
					...Object.values(possibleFilters.department as { [key: string]: any }).map((_: string, index: number) => ({
						column: "department",
						active: false,
						name: _,
						id: index + 1,
					})),
				];
				position = [
					{
						id: 0,
						name: "По умолчанию",
						column: "position",
						active: true,
					},
					...Object.values(possibleFilters.position as { [key: string]: any }).map((_: string, index: number) => ({
						column: "position",
						active: false,
						name: _,
						id: index + 1,
					})),
				];
				status = [
					{
						id: 0,
						name: "По умолчанию",
						column: "status",
						active: true,
					},
					...Object.values(possibleFilters.status as { [key: string]: any }).map((_: string, index: number) => ({
						column: "status",
						active: false,
						name: _,
						id: index + 1,
					})),
				];
				relationship = [
					{
						id: 0,
						name: "По умолчанию",
						column: "relationship",
						active: true,
					},
					...Object.values(possibleFilters.relationship as { [key: string]: any }).map((_: string, index: number) => ({
						column: "relationship",
						active: false,
						name: _,
						id: index + 1,
					})),
				];
				state.employeesFilters = {
					department,
					relationship,
					status,
					position,
				};
			}
		});
		builder.addCase(getAcriveEmployees.fulfilled, (state, action: PayloadAction<any>) => {
			const { possibleFilters, list, change } = action.payload;
			state.employeesList = list;
			let department: any[] = [],
				position: any[] = [],
				relationship: any[] = [],
				status: any[] = [];
			if (change) {
				department = [
					{
						id: 0,
						name: "По умолчанию",
						column: "department",
						active: true,
					},
					...Object.values(possibleFilters.department as { [key: string]: any }).map((_: string, index: number) => ({
						column: "department",
						active: false,
						name: _,
						id: index + 1,
					})),
				];
				position = [
					{
						id: 0,
						name: "По умолчанию",
						column: "position",
						active: true,
					},
					...Object.values(possibleFilters.position as { [key: string]: any }).map((_: string, index: number) => ({
						column: "position",
						active: false,
						name: _,
						id: index + 1,
					})),
				];
				status = [
					{
						id: 0,
						name: "По умолчанию",
						column: "status",
						active: true,
					},
					...Object.values(possibleFilters.status as { [key: string]: any }).map((_: string, index: number) => ({
						column: "status",
						active: false,
						name: _,
						id: index + 1,
					})),
				];
				relationship = [
					{
						id: 0,
						name: "По умолчанию",
						column: "relationship",
						active: true,
					},
					...Object.values(possibleFilters.relationship as { [key: string]: any }).map((_: string, index: number) => ({
						column: "relationship",
						active: false,
						name: _,
						id: index + 1,
					})),
				];
				state.employeesFilters = {
					department,
					relationship,
					status,
					position,
				};
			}
		});
		builder.addCase(getOrganizationEmployees.fulfilled, (state, action) => {
			state.employeesList.push(...action.payload);
		});
		builder.addCase(archiveEmployee.fulfilled, (state, action) => {
			// eslint-disable-next-line array-callback-return
			const newArr = state.employeesList.filter((employee) => {
				if (employee.id !== action.payload) {
					return employee;
				}
			});

			state.employeesList = [...newArr];
		});
		builder.addCase(deleteFromArchiveEmployee.fulfilled, (state, action) => {
			// eslint-disable-next-line array-callback-return
			const newArr = state.employeesList.filter((employee) => {
				if (employee.id !== action.payload) {
					return employee;
				}
			});

			state.employeesList = [...newArr];
		});
		builder.addCase(getOrganizationsName.fulfilled, (state, action) => {
			state.organizationsName = [
				{ name: "", text: "Все компании" },
				...action.payload.map((item: any) => {
					return {
						name: item.id,
						text: item.shortName,
					};
				}),
			];
		});
		builder.addCase(getEmployee.fulfilled, (state, action) => {
			state.selectedEmployee = action.payload;
		});
		builder.addCase(changeActiveFilter.fulfilled, (state, action) => {
			state.employeesFilters = action.payload;
		});
	},
});

export const { setEmployees } = employeesSlice.actions;
export default employeesSlice.reducer;
